<div class="entity-menu-dialog scroll-container">

  @if (!!monster) {
  <div class="name">
    @if (!monster.noThumbnail && settingsManager.settings.artwork) {
    <img class="standee" [src]="gameManager.monsterManager.monsterThumbnail(monster)" />
    }
    <span [ghs-label]="'data.monster.' + monster.name"></span>&nbsp;
    @if (monster.isAlly) {
    <span class="ally"><span [ghs-label]="'game.ally'"></span>&nbsp;</span>
    }
    @if (monster.isAllied) {
    <span class="allied"><span [ghs-label]="'game.allied'"></span>&nbsp;</span>
    }
    @if (data.type) {
    <span class="monster-type" [ghs-label]="'(%game.monsterType.' +  data.type + '%)'"></span>
    }
  </div>
  }

  @if (!!character) {
  <span class="name">
    <img class="icon character-icon" [src]="character.iconUrl" />
    <span>{{gameManager.characterManager.characterName(character,true)}}</span>
  </span>
  }

  <div class="entities">
    @for (entity of allEntities | trackUUID; track entity._trackUUID) {
    @if (!!monster) {
    <div class="entity {{gameManager.toMonsterEntity(entity).type}}" tabclick (click)="toggleEntity(entity)"
      [ngClass]="{'inactive' : entities.indexOf(entity) == -1}">{{entity.number}}</div>
    }
    @if (!!character) {
    <div class="entity" tabclick (click)="toggleEntity(entity)"
      [ngClass]="{'inactive' : entities.indexOf(entity) == -1}">
      <span class="summon-image"
        [ngClass]="{'active' : gameManager.toSummon(entity).state == SummonState.true, 'new' : gameManager.toSummon(entity).state == SummonState.new, 'center' : (gameManager.toSummon(entity).entityConditions.length % 2) == 0}">
        <img src="./assets/images/summons/{{gameManager.toSummon(entity).color}}.png">
        <span class="summon-number">
          @if (gameManager.toSummon(entity).number == 0) {
          <span>-</span>
          }
          @if (gameManager.toSummon(entity).number > 0) {
          <span>{{gameManager.toSummon(entity).number}}</span>
          }</span>
      </span>
    </div>
    }
    @if (!!objective) {
    <div class="entity" tabclick (click)="toggleEntity(entity)"
      [ngClass]="{'inactive' : entities.indexOf(entity) == -1}">
      <span class="objective-marker">
        {{gameManager.toObjectiveEntity(entity).number}}
      </span>
    </div>
    }
    }
  </div>

  <div class="entity-container">
    <span class="item">
      <ghs-pointer-input class="button" tabclick (singleClick)="changeHealth(-1)" [repeat]="true">
        <img class="ghs-svg" src="./assets/images/minus.svg">
      </ghs-pointer-input>
    </span>
    <span class="item" [ghs-label]="'game.health'" [ghs-label-attribute]="'title'">
      <img src="./assets/images/status/health.svg" />
      <span class="badge health-count"
        [ngClass]="{'negative-value' : health < 0, 'positive-value' : health > 0}">{{health | ghsValueSign}}</span>
    </span>
    <span class="item">
      <ghs-pointer-input class="button" tabclick (singleClick)="changeHealth(1)" [repeat]="true">
        <img class="ghs-svg" src="./assets/images/plus.svg">
      </ghs-pointer-input>
    </span>
  </div>

  @if (!!monster) {
  <ghs-conditions [entityConditions]="entityConditions" [immunities]="entityImmunities" [entities]="entities"
    [figure]="monster" [type]="'monster'" [columns]="4"></ghs-conditions>
  }

  @if (!!character) {
  <ghs-conditions [entityConditions]="entityConditions" [immunities]="entityImmunities" [entities]="entities"
    [figure]="character" [type]="'monster'" [columns]="4"></ghs-conditions>
  }

  @if (!!objective) {
  <ghs-conditions [entityConditions]="entityConditions" [immunities]="entityImmunities" [entities]="entities"
    [figure]="objective" [type]="objective.escort ? 'character' : 'objective'" [columns]="4"></ghs-conditions>
  }

  <div class="entity-container">
    <span class="item" [ghs-label]="'game.dead'" [ghs-label-attribute]="'title'">
      <a class="button" tabclick (click)="toggleDead()">
        <img src="./assets/images/status/dead.svg" />
      </a>
    </span>
    <span class="item max-health-container">
      <ghs-pointer-input class="button" tabclick (singleClick)="changeMaxHealth(-1)" [repeat]="true">
        <img class="ghs-svg" src="./assets/images/minus.svg">
      </ghs-pointer-input>
      <img src="./assets/images/status/health.svg" [ghs-label]="'game.maxHealth'" [ghs-label-attribute]="'title'" />
      <span class="badge health-count"
        [ngClass]="{'negative-value' : maxHealth < 0, 'positive-value' : maxHealth > 0}">{{maxHealth |
        ghsValueSign}}</span>
      <ghs-pointer-input class="button" tabclick (singleClick)="changeMaxHealth(1)" [repeat]="true">
        <img class="ghs-svg" src="./assets/images/plus.svg">
      </ghs-pointer-input>
    </span>
  </div>

  @if (!!monster) {
  <span class="toggle-type" tabclick (click)="toggleType()">
    <span [ghs-label]="'%game.monsterType.normal%'"></span>
    <img class="ghs-svg" src="./assets/images/switch.svg" />
    <span [ghs-label]="'%game.monsterType.elite%'"></span>
  </span>
  }
</div>